/* BZ 2026-10-31: live suggestions under the header search bar.
   As people type, matching services from the Service Store collection show
   in a list. Titles that start with the typed text come first, then titles
   with a word that starts with it, then other matches. Arrow keys move,
   Enter opens the highlighted service, Esc closes the list. */
(function () {
  if (window.__bzSuggest) return;
  window.__bzSuggest = true;

  var products = null;
  var loading = null;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function load(collectionPath) {
    if (products) return Promise.resolve(products);
    if (loading) return loading;
    var path = (collectionPath || '/collections/servicestore').split('?')[0].replace(/\/+$/, '');
    try { path = new URL(path, location.origin).pathname; } catch (e) {}
    loading = fetch(path + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (j) {
        products = (j.products || []).map(function (p) {
          var prices = (p.variants || []).map(function (v) { return parseFloat(v.price) || 0; });
          var img = p.images && p.images[0] ? p.images[0].src : '';
          return {
            title: p.title,
            url: root.replace(/\/$/, '') + '/products/' + p.handle,
            tag: (p.tags && p.tags[0]) || '',
            tags: (p.tags || []).join(' ').toLowerCase(),
            price: prices.length ? Math.min.apply(null, prices) : 0,
            img: img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120' : ''
          };
        });
        return products;
      })
      .catch(function (err) { loading = null; throw err; });
    return loading;
  }

  function score(p, q) {
    var t = p.title.toLowerCase();
    if (t.indexOf(q) === 0) return 0;
    var words = t.split(/[\s\/\-,&]+/);
    for (var i = 0; i < words.length; i++) if (words[i].indexOf(q) === 0) return 1;
    if (t.indexOf(q) > -1) return 2;
    if (p.tags.indexOf(q) > -1) return 3;
    return -1;
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function highlight(title, q) {
    var i = title.toLowerCase().indexOf(q);
    if (i < 0) return esc(title);
    return esc(title.slice(0, i)) + '<mark>' + esc(title.slice(i, i + q.length)) + '</mark>' + esc(title.slice(i + q.length));
  }

  function money(n) {
    var s = n % 1 === 0 ? n.toLocaleString('en-US') : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '$' + s;
  }

  function wire(form) {
    if (form.dataset.bzSuggestWired) return;
    var input = form.querySelector('input[type="search"], input[type="text"]');
    if (!input) return;
    form.dataset.bzSuggestWired = '1';
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');

    var box = document.createElement('div');
    box.className = 'bz-suggest';
    box.id = 'bzSuggest-' + Math.random().toString(36).slice(2, 8);
    box.setAttribute('role', 'listbox');
    box.hidden = true;
    input.setAttribute('aria-controls', box.id);
    form.classList.add('bz-suggest-host');
    /* BZ 2026-11-01: the list floats on <body> (position: fixed) right under
       the search field. Inside the header, iPhone Safari could clip it. */
    document.body.appendChild(box);

    var items = [];
    var active = -1;
    var timer = null;

    function place() {
      var r = form.getBoundingClientRect();
      if (!r.width || !r.height) { close(); return false; }
      var vv = window.visualViewport;
      var bottom = vv ? vv.offsetTop + vv.height : window.innerHeight;
      box.style.left = Math.round(r.left) + 'px';
      box.style.width = Math.round(r.width) + 'px';
      box.style.top = Math.round(r.bottom + 8) + 'px';
      box.style.maxHeight = Math.max(160, Math.round(bottom - r.bottom - 20)) + 'px';
      return true;
    }
    function onMove() { if (!box.hidden) place(); }
    window.addEventListener('scroll', onMove, { passive: true });
    window.addEventListener('resize', onMove);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', onMove);
      window.visualViewport.addEventListener('scroll', onMove);
    }

    function close() {
      box.hidden = true;
      active = -1;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    function setActive(i) {
      var rows = box.querySelectorAll('.bz-suggest__item');
      rows.forEach(function (r, k) { r.classList.toggle('is-active', k === i); r.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      active = i;
      if (rows[i]) { input.setAttribute('aria-activedescendant', rows[i].id); rows[i].scrollIntoView({ block: 'nearest' }); }
      else input.removeAttribute('aria-activedescendant');
    }

    function render(q, raw) {
      var list = products
        .map(function (p) { return { p: p, s: score(p, q) }; })
        .filter(function (x) { return x.s >= 0; })
        .sort(function (a, b) { return a.s - b.s || a.p.title.localeCompare(b.p.title); })
        .slice(0, 6)
        .map(function (x) { return x.p; });
      items = list;
      var html = '';
      list.forEach(function (p, i) {
        html += '<a class="bz-suggest__item" role="option" id="' + box.id + '-' + i + '" href="' + esc(p.url) + '">' +
          (p.img ? '<img class="bz-suggest__img" src="' + esc(p.img) + '" alt="" loading="lazy" width="40" height="40">' : '<span class="bz-suggest__img"></span>') +
          '<span class="bz-suggest__text"><span class="bz-suggest__title">' + highlight(p.title, q) + '</span>' +
          '<span class="bz-suggest__meta">' + (p.tag ? esc(p.tag) + ' · ' : '') + 'From ' + money(p.price) + '</span></span>' +
          '<svg class="bz-suggest__arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"></path></svg>' +
          '</a>';
      });
      if (!list.length) html += '<div class="bz-suggest__empty">No service starts with “' + esc(raw) + '”. Press Enter to search all services.</div>';
      html += '<button type="button" class="bz-suggest__all" data-bz-search-all>Search all services for “' + esc(raw) + '”</button>';
      box.innerHTML = html;
      box.hidden = false;
      if (!place()) return;
      input.setAttribute('aria-expanded', 'true');
      active = -1;
    }

    function update() {
      var q = input.value.trim().toLowerCase();
      if (!q) { close(); return; }
      load(form.getAttribute('data-collection-url')).then(function () {
        if (input.value.trim().toLowerCase() === q) render(q, input.value.trim());
      }).catch(function () { close(); });
    }

    var last = '';
    function changed() {
      if (input.value === last) return;
      last = input.value;
      clearTimeout(timer);
      timer = setTimeout(update, 80);
    }
    ['input', 'keyup', 'compositionend', 'change', 'search'].forEach(function (ev) { input.addEventListener(ev, changed); });
    var poll = null;
    input.addEventListener('focus', function () { clearInterval(poll); poll = setInterval(changed, 250); });
    input.addEventListener('blur', function () { clearInterval(poll); });
    input.addEventListener('focus', function () {
      load(form.getAttribute('data-collection-url')).catch(function () {});
      if (input.value.trim()) update();
    });
    input.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(Math.min(items.length - 1, active + 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(-1, active - 1)); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && active > -1 && items[active]) { e.preventDefault(); location.href = items[active].url; }
    });
    box.addEventListener('mousedown', function (e) { if (e.target.closest('.bz-suggest__item, [data-bz-search-all]')) e.preventDefault(); });
    box.addEventListener('click', function (e) {
      if (!e.target.closest('[data-bz-search-all]')) return;
      e.preventDefault();
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target) && !box.contains(e.target)) close(); });
    form.__bzClose = close;
    var closeBtn = form.querySelector('[data-nav-search-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
  }


  /* BZ 2026-10-31: when people scroll the page, the open search bar softly
     fades and slides away. It does not close while the person is typing
     in it on a phone, where the keyboard can scroll the page by itself. */
  (function () {
    var st = document.createElement('style');
    st.textContent =
      '.header-wrapper .nav-search-drawer .boldzee-nav-search-container{transition:opacity .25s ease,transform .25s ease}' +
      '.header-wrapper .nav-search-drawer:not(.open) .boldzee-nav-search-container{opacity:0;transform:translateY(-8px)}';
    document.head.appendChild(st);

    var startY = null;
    var ticking = false;
    var focusedAt = 0;
    document.addEventListener('focusin', function (e) {
      if (e.target.closest && e.target.closest('[data-nav-search-drawer]')) focusedAt = Date.now();
    });

    function openDrawer() { return document.querySelector('.header-wrapper [data-nav-search-drawer].open'); }

    function closeDrawer(d) {
      d.classList.remove('open');
      var t = document.querySelector('[aria-controls="' + d.id + '"]');
      if (t) t.setAttribute('aria-expanded', 'false');
      var fm = d.querySelector('[data-boldzee-search-form]');
      if (fm && fm.__bzClose) fm.__bzClose();
      var input = d.querySelector('input');
      if (input) { input.setAttribute('aria-expanded', 'false'); if (document.activeElement === input) input.blur(); }
      startY = null;
    }

    function check() {
      ticking = false;
      var d = openDrawer();
      if (!d) { startY = null; return; }
      var y = window.pageYOffset || document.documentElement.scrollTop;
      if (startY === null) { startY = y; return; }
      var input = d.querySelector('input');
      var typingOnTouch = input && document.activeElement === input && window.matchMedia('(hover: none)').matches;
      var justFocused = Date.now() - focusedAt < 900;
      if (typingOnTouch || justFocused) { startY = y; return; }
      if (Math.abs(y - startY) > 40) closeDrawer(d);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-nav-search-toggle]')) {
        startY = window.pageYOffset || document.documentElement.scrollTop;
      }
    }, true);
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(check); }
    }, { passive: true });
  })();

  function init() { document.querySelectorAll('.header-wrapper [data-boldzee-search-form]').forEach(wire); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
